import { Box, Paper, Stack, Typography } from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { useState } from 'react';
import { useAppSelector } from './app/hooks';
import { Locale, selectSettings } from './features/settings/settingsSlice';
import { LanguageToggle } from './app/components/LanguageToggle';
import { VChainerFooter } from './app/components/VChainerFooter';

const texts = {
    message: {
        pl: 'Dziękujemy za rejestrację w systemie V-Chainer. Prosimy oczekiwać na e-mail z potwierdzeniem akceptacji rejestracji.',
        en: 'Thank you for registering in the V-Chainer system. Please wait for an email confirming that your registration has been approved.',
        de: 'Vielen Dank für Ihre Registrierung bei V-Chainer. Bitte warten Sie auf eine E-Mail, die die Freigabe Ihrer Registrierung bestätigt.',
    },
    header: {
        pl: 'Rejestracja przesłana',
        en: 'Registration submitted',
        de: 'Registrierung eingereicht',
    },
};

export const RegistrationAwaitApprovalPanel = () => {
    const { locale } = useAppSelector(selectSettings);
    const [language, setLanguage] = useState<Locale>(locale);
    const lang = language === 'en-US' ? 'en' : language;

    return (
        <Paper
            elevation={4}
            sx={{
                p: 5,
                maxWidth: 700,
                position: 'relative',
                width: { xs: '94vw', sm: 500, md: 600 },
                borderRadius: 3,
                textAlign: 'center',
            }}
        >
            <Stack
                sx={{
                    maxWidth: 500,
                    mx: 'auto',
                    my: 4,
                    p: 4,
                    alignItems: 'center',
                    textAlign: 'center',
                }}
                spacing={2}
            >
                <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
                    <LanguageToggle onChange={setLanguage} />
                </Box>

                <MarkEmailReadIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />

                <Typography variant="h5">
                    {texts.header[lang]}
                </Typography>

                <Typography variant="subtitle1" color="text.secondary">
                    {texts.message[lang]}
                </Typography>
            </Stack>

            <VChainerFooter />
        </Paper>
    );
};
